import { render, staticRenderFns } from "./EmployeeMenu.vue?vue&type=template&id=52a5cfc0"
import script from "./EmployeeMenu.vue?vue&type=script&lang=js"
export * from "./EmployeeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports